import { FEATURES_LIMIT } from './panel-types'

// Height-matched placeholder shown while an on-demand panel is being fetched
// (cold switches only — prefetch-on-hover/idle makes most switches instant).
// Purely decorative: `aria-hidden`, no user-visible text, so it needs no i18n.
// The surrounding wrapper carries `aria-busy` for assistive tech.
export const PanelSkeleton = () => (
  <div
    aria-hidden
    className="animate-pulse rounded-xl border border-slate-200 bg-gradient-to-br from-white to-slate-50/50"
  >
    {/* Header */}
    <div className="flex items-center gap-5 p-5 lg:gap-6 lg:p-6">
      <div className="h-[80px] w-[80px] flex-shrink-0 rounded bg-slate-100 lg:h-[110px] lg:w-[110px]" />
      <div className="min-w-0 flex-1 space-y-2">
        <div className="h-5 w-1/2 rounded bg-slate-100" />
        <div className="h-4 w-1/4 rounded bg-slate-100" />
      </div>
      <div className="h-[72px] w-[72px] flex-shrink-0 rounded-full bg-slate-100" />
    </div>
    {/* Specs grid */}
    <div className="border-t border-slate-100 px-5 pt-4 pb-5 lg:px-6 lg:pb-6">
      <div className="grid grid-cols-1 gap-x-8 min-[768px]:grid-cols-2 min-[1200px]:grid-cols-3">
        {Array.from({ length: FEATURES_LIMIT }).map((_, i) => (
          <div key={i} className="flex items-center justify-between gap-3 border-b border-slate-100 py-2.5">
            <div className="h-3 w-1/2 rounded bg-slate-100" />
            <div className="h-3 w-1/3 rounded bg-slate-100" />
          </div>
        ))}
      </div>
    </div>
  </div>
)
